import { render } from "./SubMenuItemCard.vue?vue&type=template&id=563b7021&scoped=true"
import script from "./SubMenuItemCard.vue?vue&type=script&lang=js"
export * from "./SubMenuItemCard.vue?vue&type=script&lang=js"

import "./SubMenuItemCard.vue?vue&type=style&index=0&id=563b7021&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-563b7021"

export default script